import {
  faPlus,
  faTrash,
  faArrowDownShortWide,
  faArrowUpShortWide,
} from "@awesome.me/kit-c1b85ff10f/icons/classic/light";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIndexParcelTemplatesContext } from "../providers/Index";
import { useAppContext } from "../../../AppProvider";

export const useListProps = () => {
  const context = useIndexParcelTemplatesContext();
  const { dictionary } = useAppContext();

  return {
    path: `/shipment-service/parcel-templates`,
    banner: {
      enabled: false,
    },
    sorting: [
      {
        orderBy: "desc",
        column: "name",
        icon: faArrowDownShortWide,
        label: dictionary.registries.name,
        isDefault: true,
      },
      {
        orderBy: "asc",
        column: "name",
        icon: faArrowUpShortWide,
        label: dictionary.registries.name,
        isDefault: false,
      },
    ],
    type: "grid",
    pagination: { enabled: true },
    title: dictionary.parcels.packages_2_templates,
    create: {
      enabled: true,
      action: () =>
        context?.setModalConfig({
          isOpen: true,
          action: "create",
          size: "md",
          title: `${dictionary.actions.add}`,
        }),
      title: dictionary.actions.add,

      icon: faPlus,
    },
    selectRowsEnabled: { enabled: true },
    massiveActions: [
      {
        onClick: (selectedRows) =>
          context.setModalConfig({
            isOpen: true,
            size: "sm",
            title: dictionary.actions.delete_selected,
            action: "delete",
            data: selectedRows.map((item) => item.id),
          }),
        label: dictionary.actions.delete_selected,
        icon: <FontAwesomeIcon icon={faTrash} />,
        className: "button-1 button-1-danger",
      },
    ],
  };
};
